<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Puthalath Raghuprasad has many talents. His first talent is painting. His favorite medium is oil, and he creates realistic pictures on canvas, including portraits, scenery/landscapes, birds, animals, and flowers. His second talent is writing in prose, but lately, he has also written several poems. He is also proficient in inventing; he holds 21 US patents, and two of them are at different stages of manufacturing. Finally, he has formulated his own theory about the universe in which gravity and the ever-present axial rotation cooperate to give rise to the motions of all celestial bodies.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1631e2ca